export default __webpack_public_path__ + "static/media/lynnRight.f8ee0eec.png";